import { render, staticRenderFns } from "./SchemaTableConfig.vue?vue&type=template&id=1574a275"
import script from "./SchemaTableConfig.vue?vue&type=script&lang=js"
export * from "./SchemaTableConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports